import React, { useEffect, useState } from "react";
import Navbar from "../../tailwindUI/Navbar";
import Heading from "../../tailwindUI/Heading";
import classes from "../../module.css/StmAllocationStatus.module.css"; // Updated to match StmDeliveredCars
import { useNavigate } from "react-router-dom";
import "../../index.css";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Page,
  Inject,
  Resize,
  Group,
  Sort,
  ColumnMenu,
  Filter,
  Toolbar,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-react-grids";
import { registerLicense } from "@syncfusion/ej2-base";
import ErrorMessage from "../../tailwindUI/ErrorMessage";

const CBTKanpurReport = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const apiCalled = React.useRef(false);

  useEffect(() => {
    if (!apiCalled.current) {
      apiCalled.current = true;
      fetchData();
    }
  }, []);

  const LogOut = () => {
    localStorage.removeItem("UserName");
    localStorage.removeItem("FirstName");
    localStorage.removeItem("LastName");
    localStorage.removeItem("UserToken");
    localStorage.removeItem("UserRole");
    localStorage.removeItem("Location");
    localStorage.removeItem("Email");
    localStorage.removeItem("UserLoggedin");
    navigate("/login", { replace: true });
  };

  const fetchData = () => {
    setLoading(true);
    setErrorMessage("");

    const userToken = localStorage.getItem("UserToken") || "";
    const myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    const payload = {
      UserToken: userToken,
      Outlet: "Kanpur Road",
    };

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(payload),
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/srm/OutletwiseCarBookingAlldata`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result.message ===
          "Invalid User Token, The token may have expired, You may need to re-login" ||
          result.message === "Please login with a different account"
        ) {
          LogOut();
        } else if (
          result.status === "Success" &&
          result.status_code === 200 &&
          result.message === "data found successfully"
        ) {
          // Process data and convert date strings to Date objects
          const processedData = result.data.map((item) => ({
            ...item,
            FullName: `${item.customer_name || ""} ${item.LastName || ""
              }`.trim(),
          }));
          setData(processedData);
        } else if (
          result.status === "Success" &&
          result.status_code === 200 &&
          result.message === "data not found "
        ) {
          setData([]);
        } else if (result.status_code === 200 && result.status === "fail") {
          setData([]);
        } else if (result.status_code === 400) {
          setErrorMessage("Something went wrong please contact support!");
        } else {
          setErrorMessage("Unexpected error. Please contact support.");
        }
      })
      .catch((error) => {
        console.error("API error:", error);
        setErrorMessage("Something went wrong please contact support!");
      })
      .finally(() => setLoading(false));
  };

  const groupOptions = { showGroupedColumn: true };
  const filterSettings = { type: "CheckBox" }; // Changed to Menu for better date filtering
  const toolbarOptions = ["ExcelExport", "PdfExport", "CsvExport", "Search"];

  registerLicense(
    "Mgo+DSMBaFt+QHFqVk9rWU5FdUBAXWFKblF8QWBTfFhgBShNYlxTR3ZbQ15jS3padU1rUHZX;Mgo+DSMBPh8sVXJ1S0d+X1hPc0BDXnxLflF1VWFTe116d1NWESFaRnZdQV1nSH1TdEFqWndXcXBc;ORg4AjUWIQA/Gnt2VFhhQlJNfVpdXGBWfFN0RnNbdVpzflZAcC0sT3RfQF5jTX9QdkdnUHxWeXdUTw==;MTcwNTQwM0AzMjMxMmUzMTJlMzMzOWZUTFVvWkhXMTl6bXFMbDFGTEJDRzlPVlZnNzZhcmYwZ1FIYjRlVW5XejQ9;MTcwNTQwNEAzMjMxMmUzMTJlMzMzOUU5TzdEUkp0UW5NdEFMZ1JjaXFyNTdOSlcveFgvUG9rZTFiQzRBQUs3VHc9;NRAiBiAaIQQuGjN/V0d+XU9Hf1RHQmJKYVF2R2BJfVR0d19FZkwgOX1dQl9gSXpSdUVhXXZdeH1cTmk=;MTcwNTQwNkAzMjMxMmUzMTJlMzMzOUFpd1dNbkpxOW1PQjdvOWI0WUEwckIvVVUyOHAwS0xRTUgybzBCdW1jOUU9;MTcwNTQwN0AzMjMxMmUzMTJlMzMzOUNpN0NnYjVpOG5Mb3hORXltenJEUGg5YzJjbVNxcW1tTUNOWFh6QmM2SFU9;Mgo+DSMBMAY9C3t2VFhhQlJNfVpdXGBWfFN0RnNbdVpzflZAcC0sT3RfQF5jTX9QdkdnUHxXcHxSTw==;MTcwNTQwOUAzMjMxMmUzMTJlMzMzOUI0QmhiWElTNzN3dDd1aElXMWlFeDdWdTZOanJYM25MWmhKZUlSakFhMVk9;MTcwNTQxMEAzMjMxMmUzMTJlMzMzOWxrQ1hra29TS1RvRzNUa25tY2tnOVBtNDVtMlhKZ29mVi9TK2V0L0padDQ9;MTcwNTQxMUAzMjMxMmUzMTJlMzMzOUFpd1dNbkpxOW1PQjdvOWI0WUEwckIvVVUyOHAwS0xRTUgybzBCdW1jOUU9"
  );

  let gridInstance;
  let flag = true;
  function dataBound() {
    if (flag) {
      gridInstance.toolbarModule.toolbar.hideItem(2, true);
      flag = false;
    }
  }

  function toolbarClick(args) {
    switch (args.item.text) {
      case "PDF Export":
        gridInstance.pdfExport();
        break;
      case "Excel Export":
        gridInstance.excelExport();
        break;
      case "CSV Export":
        gridInstance.csvExport();
        break;
    }
  }

  const BreadCrumb = {
    pagename: "Total Booking Report",
    pagePath: "/cbt-kanpur-report",
    pagename1: "",
    pagePath1: "",
  };

  return (
    <>
      {errorMessage && <ErrorMessage message={errorMessage} />}
      <Navbar navbarType="black navbar" />
      <div className={classes.maincontainer}>
        <Heading
          headingType="Page Headings"
          headingText="Total Booking Report"
          BreadCrumb={BreadCrumb}
          BreadCrumHomeLink="/cbt-dashboard"
        />
        {loading ? (
          <div className="flex justify-center my-2">
            <img src="assets/loadingGif.gif" alt="loading" />
          </div>
        ) : (
          <div className={classes.background}>
            <div className="control-pane">
              <div className="control-section">
                <GridComponent
                  dataSource={data}
                  height="500"
                  allowPaging={true}
                  allowResizing={true}
                  allowGrouping={true}
                  allowSorting={true}
                  allowFiltering={true}
                  showColumnMenu={true}
                  groupSettings={groupOptions}
                  filterSettings={filterSettings}
                  toolbar={toolbarOptions}
                  allowExcelExport={true}
                  allowPdfExport={true}
                  toolbarClick={toolbarClick.bind(this)}
                  ref={(grid) => (gridInstance = grid)}
                  dataBound={dataBound.bind(this)}
                  pageSettings={{ pageCount: 4, pageSizes: true }}
                  autoFit={true}
                >
                  <ColumnsDirective>
                    <ColumnDirective
                      field="AsmName"
                      headerText="ASM"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="ExecutiveName"
                      headerText="Executive"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="FullName"
                      headerText="Customer Name"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="customer_mobile"
                      headerText="Customer Mobile"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="booking_amount"
                      headerText="Booking Amount"
                      width="120"
                      textAlign="Center"
                      format="N2"
                    />
                    <ColumnDirective
                      field="booking_date"
                      headerText="Booking Date"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="booking_id"
                      headerText="Booking ID"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="receipt_num"
                      headerText="Receipt No."
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="exchange"
                      headerText="Exchange"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="win_num"
                      headerText="VIN"
                      width="150"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="status"
                      headerText="Allocation Status"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="car_model"
                      headerText="Model 1"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="car_variant"
                      headerText="Variant 1"
                      width="150"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="car_colour"
                      headerText="Colour 1"
                      width="120"
                      textAlign="Center"
                    />

                    <ColumnDirective
                      field="CSModel"
                      headerText="Allocated Model"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="CSVarient"
                      headerText="Allocated Variant"
                      width="150"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="CSColour"
                      headerText="Allocated Colour"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="CSFuleType"
                      headerText="Allocated Fuel"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="delivery_status"
                      headerText="Delivery Status"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="allocated_on"
                      headerText="Allocated On"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="CreatedAt"
                      headerText="Created On"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="delivered_on"
                      headerText="Delivered On"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="urgency"
                      headerText="Urgency"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="GetPassNumber"
                      headerText="Get Pass Number"
                      width="120"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="CBTRemark"
                      headerText="CBT Remark"
                      width="150"
                      textAlign="Center"
                    />
                    <ColumnDirective
                      field="CBTRemarkScheduleDate"
                      headerText="CBT Remark Schedule Date"
                      width="120"
                      textAlign="Center"
                    />
                  </ColumnsDirective>
                  <Inject
                    services={[
                      Resize,
                      Group,
                      Sort,
                      ColumnMenu,
                      Filter,
                      Page,
                      Toolbar,
                      ExcelExport,
                      PdfExport,
                    ]}
                  />
                </GridComponent>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CBTKanpurReport;
